import type { PluginDescription } from "./plugin-description";
// TTS functionality removed
import { registeredPlugins } from "../../plugins";

export const pluginMetadata: Array<PluginDescription> = registeredPlugins.map(p => new p().describe());
export const pluginIDs: string[] = pluginMetadata.map(d => d.id);

// TTS functionality removed

export function getPluginByName(name: string) {
    return registeredPlugins.find(p => new p().describe().name === name);
}
